import { Container, Row, Col } from 'react-bootstrap';
import { SimpleAncerSmall } from '../../../Components/button';
import { CardWithHeaderImage } from '../../../Components/Card';
import {
  HeadingDescSmall,
  HeadingWithSpaceLarge,
  SectionHeadingSmall
} from '../../../Components/Headings';
import SectionHeadingWithLinkSmall from '../../../Components/sectionHeadingWithLinkSmall/SectionHeadingWithLinkSmall';
import HealthCheckLayout from '../healthCheckLayout/HealthCheckLayout';
import arrowPink from '../../../assets/images/svg/arrow-pink.svg';
import image1 from '../../../assets/images/png/pics/icon6.png';
import image2 from '../../../assets/images/png/pics/icon3.png';
import image3 from '../../../assets/images/png/pics/icon4.png';
import './healthCheckSubscription.css';

function HealthCheckSubscription() {
  return (
    <HealthCheckLayout>
      <section className="healthCheckSubscription">
        <Container>
          <HeadingWithSpaceLarge text="HEALTHCHECK & HISTORY" />
          <Row>
            <Col md={7}>
              <div className="leftBox">
                <CardWithHeaderImage
                  topic="Our HealthCheck tool uses your phone or laptop camera to measure your health in just 60 seconds."
                  desc="Meri Sehat extracts health measurements from a video stream of exposed skin on the surface of a human face."
                  btnText="LEARN MORE ABOUT THE TOOL"
                />
                <SimpleAncerSmall text="scan your vitals now" to="/" />

                <img src={image1} alt="image1" className="image image1" />
                <img src={image3} alt="image3" className="image image2" />
                <img src={image2} alt="image2" className="image image3" />
              </div>
            </Col>
            <Col md={1} />
            <Col md={4}>
              <div className="rightBox whiteBox">
                <SectionHeadingSmall text="No History Saved!" />
                <HeadingDescSmall text="Buy our subscription to save your and your loved ones HealthCheck history with multiple scans in a single day!" />
                <SectionHeadingWithLinkSmall
                  icon={arrowPink}
                  link="/"
                  linkText="BUY SUBSCRIPTION"
                />
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </HealthCheckLayout>
  );
}

export default HealthCheckSubscription;
